import {
  FILES_FILTER,
  FILES_FILTER_SUCCESS,
  FILES_FILTER_ERROR,
  FILES_SEGMENTS,
  FILES_SEGMENTS_SUCCESS,
  FILES_SEGMENTS_ERROR,
  FILES_LIST,
  FILES_LIST_SUCCESS,
  FILES_LIST_ERROR,
} from "./actionTypes"

const initialState = {
  responseFilter: null,
  loadingFilter: false,
  errorFilter: "",
  responseSegments: null,
  loadingSegments: false,
  errorSegments: "",
  responseList: null,
  loadingList: false,
  errorList: "",
}

const Files = (state = initialState, action) => {
  switch (action.type) {
    case FILES_FILTER:
      state = {
        ...state,
        responseFilter: null,
        loadingFilter: true,
        errorFilter: "",
        responseList: null,
      }
      break
    case FILES_FILTER_SUCCESS:
      state = {
        ...state,
        responseFilter: action.payload.data,
        loadingFilter: false,
      }
      break
    case FILES_FILTER_ERROR:
      state = {
        ...state,
        loadingFilter: false,
        errorFilter: action.payload,
      }
      break
    case FILES_SEGMENTS:
      state = {
        ...state,
        loadingSegments: true,
        errorSegments: "",
      }
      break
    case FILES_SEGMENTS_SUCCESS:
      state = {
        ...state,
        loadingSegments: false,
        responseSegments: action.payload.data
      }
      break
    case FILES_SEGMENTS_ERROR:
      state = {
        ...state,
        loadingSegments: false,
        errorSegments: action.payload
      }
      break
    case FILES_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case FILES_LIST_SUCCESS:
      state = {
        ...state,
        responseList: action.payload.data,
        loadingList: false,
      }
      break
    case FILES_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload,
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Files
